import { APIRuntimeBuilder } from '@cian/mf-registry/browser';

import { IOpenAuthModalParameters, openAuthModalHandler } from './open-auth-modal';
import { ISetRegionIdParameters, setRegionIdHandler } from './set-region-id';
import { updateHeaderHandler } from './update-header';
import { IApplicationContext } from '../../../shared/types/applicationContext';
import { TReduxStore } from '../../../shared/types/redux';

export function buildAPIRuntime(_context: IApplicationContext, store: TReduxStore): APIRuntimeBuilder {
  return [
    {
      path: '/v2/open-auth-modal/',
      handler: async (parameters: IOpenAuthModalParameters) => openAuthModalHandler(store, parameters),
    },
    {
      path: '/v2/set-region-id/',
      handler: async (parameters: ISetRegionIdParameters) => setRegionIdHandler(store, parameters),
    },
    {
      path: '/v2/update-header/',
      handler: async () => updateHeaderHandler(store),
    },
  ];
}
